export default function defineCenter(markers, center) {
  let newCenter = center;
  const allLatitude = [];
  const allLongitude = [];
  if (markers.length !== 0) {
    markers.forEach((marker) => {
      allLatitude.push(marker.position.lat);
      allLongitude.push(marker.position.lng);
    });
    const minLatitude = Math.min(...allLatitude);
    const minLongitude = Math.min(...allLongitude);
    const maxLatitude = Math.max(...allLatitude);
    const maxLongitude = Math.max(...allLongitude);
    newCenter = {
      lat: minLatitude + (maxLatitude - minLatitude) / 2,
      lng: minLongitude + (maxLongitude - minLongitude) / 2,
    };
  }
  return newCenter;
}



// WEBPACK FOOTER //
// ./src/services/general/defineCenter.js